import { render, staticRenderFns } from "./property-detail-table.vue?vue&type=template&id=50352488&scoped=true&"
import script from "./property-detail-table.vue?vue&type=script&lang=js&"
export * from "./property-detail-table.vue?vue&type=script&lang=js&"
import style0 from "./property-detail-table.vue?vue&type=style&index=0&id=50352488&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50352488",
  null
  
)

export default component.exports